PegasusTemplate.MainTabPanelWrapperView = Em.View.extend({
  classNames: ['main-tab-panel']
});
